import { render } from "./LeftSideBar.vue?vue&type=template&id=40ad7493&scoped=true"
import script from "./LeftSideBar.vue?vue&type=script&lang=js"
export * from "./LeftSideBar.vue?vue&type=script&lang=js"

import "./LeftSideBar.vue?vue&type=style&index=0&id=40ad7493&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ad7493"]])

export default __exports__